/**
 * Array of all valid redemption redeem include relations
 * Used for runtime validation
 */
export const VALID_REDEMPTION_REDEEM_RELATIONS = [
    'redemption',
    'user',
    'business',
    'transactions'
];
/**
 * Type guard to validate redemption redeem include relation at runtime
 *
 * @param value - String to validate
 * @returns True if value is a valid RedemptionRedeemIncludeRelation
 */
export function isValidRedemptionRedeemRelation(value) {
    return VALID_REDEMPTION_REDEEM_RELATIONS.includes(value);
}
//# sourceMappingURL=redemption-redeem-include-relation.type.js.map